module.exports = __webpack_public_path__ + "img/palm-beach.ec4ea654.jpg";